import { render, staticRenderFns } from "./SinMovimiento.vue?vue&type=template&id=c600cc18&"
import script from "./SinMovimiento.vue?vue&type=script&lang=ts&"
export * from "./SinMovimiento.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports